var render = function render(){var _vm=this,_c=_vm._self._c;return _c('formio-builder-component',{staticClass:"formio-builder-component",attrs:{"formExpansionDefinition":_vm.formDefinition,"createNew":_vm.createNew,"baseOptions":_vm.baseOptions},on:{"close":_vm.closeFormioBuilder}})
}
var staticRenderFns = []

export { render, staticRenderFns }